import { APIResponse } from '../../../../@types/api-response';
import balanceEndpoint from '../constants/apiEndpoints/balance';
import { CashInfoResponse, CashOnHandResponse } from '../types/api/balance';
import { getTradingApiInstance } from './instance/trading';

export const getCashInfo = async (
  stockCode: string,
  orderId?: string,
): Promise<APIResponse<CashInfoResponse>> =>
  getTradingApiInstance().get(balanceEndpoint.cashInfo, {
    params: {
      stock_code: stockCode,
      order_id: orderId,
    },
  });

export const getCashOnHand = async (): Promise<
  APIResponse<CashOnHandResponse>
> => getTradingApiInstance().get(balanceEndpoint.cashOnHand);
